// Google Analytics 4 configuration
export const GA4_STREAM_ID = process.env.NEXT_PUBLIC_GA_STREAM_ID || '3031507409'
export const GA4_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || 'G-3KSMQENHKY'
// Google Ads configuration
export const GOOGLE_ADS_CONVERSION_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_ID || 'G-GVYWLKYEE0'

// Helper function to check if GA is loaded
export const isGaLoaded = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

// Enhanced event tracking for GA4
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (isGaLoaded() && GA4_MEASUREMENT_ID) {
    window.gtag('event', eventName, eventParams)
  }
}

// Enhanced ecommerce tracking for GA4
export const trackPurchase = (transactionId: string, value: number, currency: string = 'EUR', items: any[] = []) => {
  if (isGaLoaded() && GA4_MEASUREMENT_ID) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: items,
    })
  }
}
